<template>
  <div>
    <div class="vs-row">
     
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-card class="cardx">
              <div class="flex items-center">
                <i class="icon-basket mr-5 h2"></i>
                <div class="card-liner-content">
                  <h5 class="font-medium">2,390</h5>
                  <p class="font-medium mt-2">Today's Orders</p>
                </div>
              </div>
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todayorders.options"
                :series="ChartOptions.todayorders.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-card class="cardx">
              <div class="flex items-center">
                <i class="icon-user mr-5 h2"></i>
                <div class="card-liner-content">
                  <h5 class="font-medium">9,390</h5>
                  <p class="font-medium mt-2">Today's Visitors</p>
                </div>
              </div>
              <vs-chip class="absolute top-0 right-0 mt-3 mr-3" color="primary">+4.8%</vs-chip>
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todayvisitors.options"
                :series="ChartOptions.todayvisitors.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-card class="cardx">
              <div class="flex items-center">
                <i class="icon-bag mr-5 h2"></i>
                <div class="card-liner-content">
                  <h5 class="font-medium">$4,390</h5>
                  <p class="font-medium mt-2">Today's Sale</p>
                </div>
              </div>
              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.todaysale.options"
                :series="ChartOptions.todaysale.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
          <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
            <vs-card class="cardx">
              <div class="flex items-center">
                <span class="mr-5 h2">$</span>
                <div class="card-liner-content">
                  <h5 class="font-medium">$4,390</h5>
                  <p class="font-medium mt-2">Total Profit</p>
                </div>
              </div>

              <vue-apex-charts
                class="mt-3"
                height="80"
                type="line"
                :options="ChartOptions.totalprofit.options"
                :series="ChartOptions.totalprofit.series"
              ></vue-apex-charts>
            </vs-card>
          </vs-col>
           <vs-col vs-lg="8" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content">
            <vue-apex-charts
            class="mt-3"
            height="390"
            type="area"
            :options="ChartOptions.mainbarchart.options"
            :series="ChartOptions.mainbarchart.series"
          ></vue-apex-charts>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">New Users</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <div v-for="(user,index) in users" v-bind:key="index" class="flex p-3 border bottom">
              <img
                key="onlineImg4"
                :src="user.img"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <div class="pl-3">
                <span class="font-semibold">{{user.name}}</span>
                <br />
                <p class="font-medium">{{user.address}}</p>
              </div>
              <vs-spacer />
              <vs-dropdown>
                <span class="cursor-pointer">
                  <i class="icon-options icons h6 font-weight-bold"></i>
                </span>
                <vs-dropdown-menu>
                  <vs-dropdown-item>
                    <span class="icon-pencil mr-2 h6 mb-0"></span> Edit Profile
                  </vs-dropdown-item>
                  <vs-dropdown-item>
                    <span class="icon-user mr-2 h6 mb-0"></span> View Profile
                  </vs-dropdown-item>
                  <vs-dropdown-item divider class="text-danger">
                    <span class="icon-trash mr-2 h6 mb-0"></span> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      </vs-col>        
      
    </div>
    
    <div class="vs-row">
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">       
        <vs-card class="cardx ">
          <p class="mb-5 font-semibold">Onboard  &gt; Site Tracking</p>
          <p class="font-medium mb-3">
            <i class="icon-calendar"></i> March 14th, 2021
          </p>
          <p class="font-medium mb-3">Time estimate: 12 days</p>
          <div class="flex mt-5">
            <div class="my-auto line-h-1">
              <span class="badge outline-badge-secondary rounded">Medium</span>
              <span class="badge outline-badge-success ml-2 rounded">Tracking</span>
            </div>
            <vs-spacer />
            <img
              key="onlineImg2"
              src="@/assets/images/author9.jpg"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
        </vs-card>
       
      </vs-col>
      
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
       
        <vs-card class="cardx">
          <p class="mb-5 font-semibold">View Order &gt; Confirm Order</p>
          <p class="font-medium mb-3">
            <i class="icon-calendar"></i> March 14th, 2021
          </p>
          <p class="font-medium mb-3">Time estimate: 12 days</p>
          <div class="flex mt-5">
            <div class="my-auto line-h-1">
              <span class="badge outline-badge-secondary rounded">Medium</span>
              <span class="badge outline-badge-success ml-2 rounded">Tracking</span>
            </div>
            <vs-spacer />
            <img
              key="onlineImg2"
              src="@/assets/images/author6.jpg"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
        </vs-card>
       
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
       
        <vs-card class="cardx">
          <p class="mb-5 font-semibold">Order Placed &gt; Site Tracking</p>
          <p class="font-medium mb-3">
            <i class="icon-calendar"></i> March 14th, 2021
          </p>
          <p class="font-medium mb-3">Time estimate: 12 days</p>
          <div class="flex mt-5">
            <div class="my-auto line-h-1">
              <span class="badge outline-badge-secondary rounded">Medium</span>
              <span class="badge outline-badge-info ml-2 rounded">Tracking</span>
            </div>
            <vs-spacer />
            <img
              key="onlineImg2"
              src="@/assets/images/author7.jpg"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
        </vs-card>
       
      </vs-col>
      <vs-col vs-lg="3" vs-sm="6" vs-xs="12">
       
        <vs-card class="cardx">
          
          <p class="mb-5 font-semibold">Pickup &gt; Picking Order</p>
          <p class="font-medium mb-3">
            <i class="icon-calendar"></i> March 14th, 2021
          </p>
          <p class="font-medium mb-3">Time estimate: 12 days</p>
          <div class="flex mt-5">
            <div class="my-auto line-h-1">
              <span class="badge outline-badge-warning rounded">Medium</span>
              <span class="badge outline-badge-danger ml-2 rounded">Tracking</span>
            </div>
            <vs-spacer />
            <img
              key="onlineImg2"
              src="@/assets/images/author8.jpg"
              alt="user-img"
              width="30"
              height="30"
              class="rounded-full shadow-md cursor-pointer block"
            />
          </div>
        </vs-card>
       
      </vs-col>
<vs-col vs-lg="4" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <div class="vs-card--content p-0">
            <vs-table stripe :data="rows">
              <template slot="thead">
                <vs-th>States</vs-th>
                <vs-th>Orders</vs-th>
                 <vs-th>Earning</vs-th>
              </template>
              <template>
                <vs-tr class="border top" :key="indextr" v-for="(staterow, indextr) in staterows">
                  <vs-td :data="staterow.states">{{staterow.state}}</vs-td>
                  <vs-td :data="staterow.orders" >
                    {{staterow.orders}}
                  </vs-td>
                 <vs-td :data="staterow.earning" >
                    {{staterow.earning}}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
        <vs-col vs-lg="8" vs-sm="6" vs-xs="12">
        <div class="con-vs-card cardx overflow-hidden">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Recent Orders</h6>
            </div>
          </header>
          <div class="vs-card--content p-0">
            <vs-table stripe :data="rows">
              <template slot="thead">
                <vs-th>ID</vs-th>
                <vs-th>Purchased</vs-th>
                <vs-th>Client Name</vs-th>
                <vs-th>Amount</vs-th>
                <vs-th>Quantity</vs-th>
                <vs-th>Shipment</vs-th>
                <vs-th>Status</vs-th>
              </template>
              <template>
                <vs-tr class="border top" :key="indextr" v-for="(row, indextr) in rows">
                  <vs-td :data="row.id">{{row.id}}</vs-td>
                  <vs-td :data="row.purchased">
                    {{row.purchased}}
                  </vs-td>
                  <vs-td :data="row.name">
                    {{row.name}}
                  </vs-td>
                  <vs-td :data="row.amount">
                    {{row.amount}}
                  </vs-td>
                  <vs-td :data="row.quantity">
                    {{row.quantity}}
                  </vs-td>
                  <vs-td :data="row.shipment">
                    {{row.shipment}}
                  </vs-td>
                  <vs-td :data="row.status">
                    <span class="badge" :class="row.color">{{row.status}}</span>
                    
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
import ChartjsLineChart from "../components/chartjs/ChartjsLineChart.vue";
import VueApexCharts from "vue-apexcharts";
import EcommerceChart from "@/demo-data/ecommerce.js";
export default {
  components: {
    VueApexCharts,
    ChartjsLineChart
  },
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      var keys = Object.keys(this.ChartOptions);

      for (var i = 0; i < keys.length; i++) {
        this.ChartOptions[keys[i]].options = {
          theme: {
            mode: mode,
          },
        };
      }
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      ChartOptions: EcommerceChart[0],
       staterows: [
        {
          state: "California",
          orders: "5,201",
          earning: "$80,200.70"
        },
        {
          state: "Texas",
          orders: "9,950",
          earning: "$78,410.30"
        },
        {
          state: "Wyoming",
          orders: "6,158",
          earning: "$162,050.20"
        },
        {
          state: "Florida",
          orders: "7,875",
          earning: "$187,792.10"
        },
        {
          state: "New York",
          orders: "12,560",
          earning: "$13,087.90"
        },
      ],
      users: [
        {
          name: "Jonathan",
          img: require("@/assets/images/author1.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "kelvin",
          img: require("@/assets/images/author2.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Peter",
          img: require("@/assets/images/author3.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Ray Sin",
          img: require("@/assets/images/author9.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Abexon Dixon",
          img: require("@/assets/images/author6.jpg"),
          address: "San Francisco, California, USA",
        },
        {
          name: "Nathan S. Johnson",
          img: require("@/assets/images/author7.jpg"),
          address: "San Francisco, California, USA",
        },
      ],
      rows: [
        {
          id: "0001",
          purchased: "03/11/2015",
          name: "Addison Nichols",
          amount: "$ 515.20",
          quantity: "547",
          shipment: "04/10/2017",
          status: "Standby",
          color: "outline-badge-primary"
        },
        {
          id: "0002",
          purchased: "03/11/2015",
          name: "Albert Watkins",
          amount: "$ 515.20",
          quantity: "547",
          shipment: "04/10/2017",
          status: "Paid",
          color: "outline-badge-success"
        },
        {
          id: "0003",
          purchased: "03/11/2015",
          name: "Johnny Fernandez",
          amount: "$ 515.20",
          quantity: "547",
          shipment: "04/10/2017",
          status: "Canceled",
          color: "outline-badge-danger"
        },
        {
          id: "0004",
          purchased: "03/11/2015",
          name: "Nora Lambert",
          amount: "$ 515.20",
          quantity: "547",
          shipment: "04/10/2017",
          status: "Standby",
          color: "outline-badge-primary"
        }
       
      ],
    };
  },
};
</script>